module.exports = __webpack_public_path__ + "/images/logo-af-babypark.3b0929d.webp";